@if (threads?.length > 0) {
  <span class="card-comments-count"
        (click)="toggleThreads()">
        {{ threads.length  }} {{ (threads.length === 1 ? 'comment-card.comment': 'comment-card.comments') | translate}}
  </span>
}